import {
  PEOPLE_CASE_STUDY,
  PEOPLE_CTA,
  PEOPLE_DELIVERY,
  PEOPLE_HERO,
  PEOPLE_PROBLEMS,
  PEOPLE_SEO,
  PEOPLE_WHAT_WHO,
} from '@/data/people';
import { SITE_ORIGIN, useSeo } from '@/lib/seo';
import { ServiceLineHero } from '@/components/site/service/ServiceLineHero';
import { ServiceWhatWho } from '@/components/site/service/ServiceWhatWho';
import { ServiceProblems } from '@/components/site/service/ServiceProblems';
import { ServiceDelivery } from '@/components/site/service/ServiceDelivery';
import { ServiceCaseStudy } from '@/components/site/service/ServiceCaseStudy';
import { PeopleServices } from '@/components/site/people/PeopleServices';
import { CtaBand } from '@/components/site/CtaBand';

const ACCENT = '#D6318B';
const ACCENT_DARK = '#A01E66';
const ACCENT_SOFT = '#FBDCEE';

export default function PeoplePage() {
  const origin = SITE_ORIGIN;

  useSeo({
    title: PEOPLE_SEO.title,
    description: PEOPLE_SEO.description,
    canonical: `${origin}/services/people`,
    ogImage: `${origin}/assets/amden-logo-dark.png`,
    jsonLd: {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Amden People',
      provider: { '@type': 'Organization', name: 'Amden Group' },
      serviceType: 'HR consultancy, recruitment and people development',
      areaServed: ['Ireland', 'United Kingdom'],
      description: PEOPLE_SEO.description,
      url: `${origin}/services/people`,
    },
  });

  return (
    <>
      <ServiceLineHero
        content={PEOPLE_HERO}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        accentSoft={ACCENT_SOFT}
        testidPrefix="people"
      />
      <ServiceWhatWho
        data={PEOPLE_WHAT_WHO}
        accent={ACCENT}
        accentSoft={ACCENT_SOFT}
        testidPrefix="people"
      />
      <ServiceProblems
        data={PEOPLE_PROBLEMS}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        accentSoft={ACCENT_SOFT}
        index="02"
        discussHref="/?service=people#solution-finder"
        testidPrefix="people"
      />
      <PeopleServices />
      <ServiceDelivery
        data={PEOPLE_DELIVERY}
        accent={ACCENT}
        index="04"
        testidPrefix="people"
        sectionClass="bg-white"
      />
      <ServiceCaseStudy
        data={PEOPLE_CASE_STUDY}
        accent={ACCENT}
        accentDark={ACCENT_DARK}
        index="05"
        testidPrefix="people"
      />
      <CtaBand
        index={PEOPLE_CTA.index}
        eyebrow={PEOPLE_CTA.eyebrow}
        heading={PEOPLE_CTA.heading}
        copy={PEOPLE_CTA.copy}
        primaryLabel={PEOPLE_CTA.primaryLabel}
        primaryHref={PEOPLE_CTA.primaryHref}
        secondaryLabel={PEOPLE_CTA.secondaryLabel}
        secondaryHref={PEOPLE_CTA.secondaryHref}
      />
    </>
  );
}
